<form [formGroup]="formGroup"
      (ngSubmit)="onSpecializedExportSubmit()">
    <p>Select the data point you want to export:</p>

    <mat-radio-group class="export__radiogroup"
                     required
                     formControlName="specializedExportType">
        <mat-radio-button [disableRipple]="true"
                          class="d-block"
                          value="email_addresses">
            Email Addresses
        </mat-radio-button>
        <mat-radio-button [disableRipple]="true"
                          class="d-block"
                          value="phone_numbers">
            Phone Numbers
        </mat-radio-button>
        <mat-radio-button [disableRipple]="true"
                          class="d-block"
                          value="home_addresses">
            Home Addresses
        </mat-radio-button>
        <mat-radio-button [disableRipple]="true"
                          class="d-block"
                          value="notes">
            Notes
        </mat-radio-button>

        <ng-container *ngIf="connectionTypeOptions.length > 0">
            <mat-radio-button [disableRipple]="true"
                              class="d-block"
                              value="entity_connections">
                Connections <i class="fal fa-info-circle"
                   matTooltip="Exported data will be limited to only the connections created within this campaign."
                   matTooltipPosition="above"></i>
            </mat-radio-button>

            <mat-form-field class="col__ mt-0050"
                            *ngIf="specializedExportType === 'entity_connections'">
                <mat-label>Export Connections of Type</mat-label>
                <mat-select placeholder="Connection Type"
                            name="role"
                            required
                            formControlName="selectedEntityConnectionType">
                    <mat-select-trigger>
                        <app-connection-type-name [connectionType]="selectedEntityConnectionType">
                        </app-connection-type-name>
                    </mat-select-trigger>
                    <mat-option *ngFor="let ect of connectionTypeOptions"
                                [value]="ect">
                        <app-connection-type-name [connectionType]="ect">
                        </app-connection-type-name>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
    </mat-radio-group>

    <button type="submit"
            class="btn vert-0150"
            [disabled]="formGroup.invalid">
        Process Export
    </button>

</form>
